module.exports = __webpack_public_path__ + "img/款式设计ico.c410e495.png";